import { render } from "./ModalWindow.vue?vue&type=template&id=853b7f08&ts=true"
import script from "./ModalWindow.vue?vue&type=script&lang=ts"
export * from "./ModalWindow.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__